import { action, makeAutoObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export type ProviderType = 'azure' | 'jira';

export interface ProviderConfig {
  url: string;
  token: string;
  email?: string;
}

export default class ProviderStore {
  @observable
  selectedProvider: ProviderType | null = null;

  @observable
  config: Partial<Record<ProviderType, ProviderConfig>> = {};

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'ProviderStore',
      properties: ['selectedProvider', 'config'],
      storage: window.localStorage,
    });
  }

  @action
  selectProvider(provider: ProviderType | null) {
    this.selectedProvider = provider;
  }

  @action
  setConfig(provider: ProviderType, config: ProviderConfig) {
    this.config[provider] = config;
  }

  @action
  clearConfig(provider: ProviderType) {
    delete this.config[provider];
  }
} 